export default __webpack_public_path__ + "static/selfapp-watch-86b638ea7ca895a9a8bc45227aecd806.jpg";